export default __webpack_public_path__ + "static/media/CNo.87-1.ad670177.jpg";